/**
 * サイドバー項目名。キーは NAV_ITEMS の NavItem.key と一致させる。
 * 項目そのものの定義は src/components/layout/nav-items.ts（issue #29 の大項目 1〜10）。
 */
export default {
  sectionBusiness: "業務",
  sectionAdmin: "管理",
  sectionDesign: "設計",
  sectionSettings: "設定",
  plannedBadge: "準備中",
  items: {
    home: "ホーム",
    myApplications: "マイ案件",
    approvalRequests: "承認リクエスト",
    notifications: "通知",
    allCases: "全案件モニタ",
    permissions: "所属と権限",
    activityLog: "操作履歴",
    processDesign: "プロセス設計",
    secrets: "Secrets・認証連携",
  },
} as const;
